export default __webpack_public_path__ + "static/media/pursuit_icon_and_shadow.330c2ddd.svg";